import { forwardRef, Ref, type SVGProps } from 'react';

const SvgTree = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <path
      fill="#033532"
      d="M10.376 0 7.938 2.628V5.52l1.446 2.76-.426 1.504-2.632-4.25-1.708-1.248-2.574-1.482-.306 2.832 1.338 2.756 5.602 2.652-.396 1.95-2.088-2.21L3.632 9.8l-2.432.724.92 1.972 2.3 2.102 3.716.7-1.328 4.156h5.074l-1.042-4.222 4.434-.152 2.014-1.328.516-1.66-.362-1.81-3.614.724-2.988 2.386.08-1.966 2.972-1.532 2.762-.132 1.774-1.84.196-3.548-3.154.59-4.596 4.34.032-1.22 1.84-2.234V2.628z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgTree);
export default ForwardRef;
